import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.0002 7.99975C21.0002 8.25575 20.9023 8.51175 20.7073 8.70675L12.7072 16.7068C12.3162 17.0978 11.6842 17.0978 11.2933 16.7068L3.29325 8.70675C2.90225 8.31575 2.90225 7.68375 3.29325 7.29275C3.68425 6.90175 4.31625 6.90175 4.70725 7.29275L12.0002 14.5858L19.2932 7.29275C19.6842 6.90175 20.3162 6.90175 20.7073 7.29275C20.9023 7.48775 21.0002 7.74375 21.0002 7.99975Z",
		fill: "currentColor"
	})
});
export default SvgArrowDown;
